import { useAnyContextNoteId } from './useAnyContextNoteId';
import { getUserIdFromToken } from './useMe';
import { useNote } from './useNote';
export var useNoteOwnerId = function () {
    var _a;
    var userId = getUserIdFromToken().userId;
    var noteId = useAnyContextNoteId();
    var data = useNote(noteId).data;
    // If a note ID exists, get ownerId for note. Otherwise, a new note is owned by current provider.
    return (_a = data === null || data === void 0 ? void 0 : data.ownerId) !== null && _a !== void 0 ? _a : userId;
};
